import { NAME } from 'domain/stockUnit/constants';

export const INIT = `${NAME}/INIT`;
